import React, { Component } from 'react'
import Airline from './Airline'
import CabinClass from './CabinClass'
import CombinedFlight from './CombinedFlight'
import FlightMoreOptions from './FlightMoreOptions'

class FlightServiceAlternative extends Component {
  constructor(){
    super()
    this.state = {
      moreOptions: false
    }
  }

  componentWillMount()
  {
    if (this.props.serviceAlternative.get('serviceDetail').count()>1)
    {
      this.setState({moreOptions: this.props.showMoreOptions})
    }
  }

  toggleMoreOptions()
  {
    this.setState({moreOptions:!this.state.moreOptions})
  }

  updateSelectedURI = selectedURI =>
  {
    this.setState({moreOptions: false})
    this.props.updateSelectedURIs(selectedURI)  
  }

  render(){
    const {serviceAlternative, airportByIata, selectedServiceURI} = this.props
    const {moreOptions} = this.state
    const chosenServiceDetail = serviceAlternative.get('serviceDetail').get(selectedServiceURI)
    return <div>
            <div className="row result-item">
                <div className="col-sm-3 col-lg-4 airline-col">
                    <Airline airline={chosenServiceDetail.get('serviceProvider')} />
                </div>
                <CombinedFlight serviceDetail={chosenServiceDetail} airportByIata={airportByIata} numberOfOptions={serviceAlternative.get('serviceDetail').count() - 1} toggleMoreOptions={this.toggleMoreOptions.bind(this)}/>
                <div className="col-sm-4 col-lg-3 class-col">
                    <CabinClass serviceDetail={chosenServiceDetail} />
                </div>
            </div>
            { moreOptions ? <FlightMoreOptions serviceAlternative={serviceAlternative} selectedURI = {selectedServiceURI} select={this.updateSelectedURI}/> : null}
          </div>
  }
}

export default FlightServiceAlternative



// WEBPACK FOOTER //
// ./src/ndc/offer/FlightServiceAlternative.js